import React from "react";
import { Modal } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { DRAWER_TYPES } from "Constantes/drawers";
import { setActiveDrawer } from "../../Slices/uiSlice";
import { Menu } from "../Menu/Menu";
import "./MenuModal.scss";

/**
* Componente modal que contiene el menú principal de la aplicación.
* Utiliza Material-UI Modal y se controla mediante Redux para mostrar/ocultar.
* @returns {JSX.Element} Componente MenuModal renderizado
*/
export const MenuModal = () => {
  const dispatch = useDispatch();
  const activeDrawer = useSelector((state) => state.ui.activeDrawer);
  const open = activeDrawer === DRAWER_TYPES.MENU;

  const onClose = () => {
    dispatch(setActiveDrawer(null));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="menu-modal"
      className="menu-modal"
    >
      <div className="menu-card">
        <Menu onClose={onClose} />
      </div>
    </Modal>
  );
};
